function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_ROLE_LOGIN = '/login';

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
};

export const PATH_ROLE_LOGIN = {
  root: ROOTS_ROLE_LOGIN,
  admin: path(ROOTS_ROLE_LOGIN, '/admin'),
  company: path(ROOTS_ROLE_LOGIN, `/company`),
  officer: path(ROOTS_ROLE_LOGIN, '/officer'),
  member: path(ROOTS_ROLE_LOGIN, '/member'),
  register: path(ROOTS_ROLE_LOGIN, '/register'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  dorm: {
    app: path(ROOTS_DASHBOARD, '/'),
    dorm: path(ROOTS_DASHBOARD, '/dorm'),
    editdorm: (id) => path(ROOTS_DASHBOARD, `/editdorm/${id}`),
    adddorm: path(ROOTS_DASHBOARD, '/adddorm'),
  },

  magictype: {
    app: path(ROOTS_DASHBOARD, '/'),
    magictype: path(ROOTS_DASHBOARD, '/magictype'),
    editmagictype: (id) => path(ROOTS_DASHBOARD, `/editmagictype/${id}`),
    addmagictype: path(ROOTS_DASHBOARD, '/addmagictype'),
  },

  rarity: {
    app: path(ROOTS_DASHBOARD, '/'),
    rarity: path(ROOTS_DASHBOARD, '/rarity'),
    editrarity: (id) => path(ROOTS_DASHBOARD, `/editrarity/${id}`),
    addrarity: path(ROOTS_DASHBOARD, '/addrarity'),
  },
  review: {
    app: path(ROOTS_DASHBOARD, '/'),
    review: path(ROOTS_DASHBOARD, '/review'),
    addReview: path(ROOTS_DASHBOARD, '/addreview'),
    editReview: (id) => path(ROOTS_DASHBOARD, `/editreview/${id}`),
  },
  cancellationPolicy: {
    app: path(ROOTS_DASHBOARD, '/'),
    cancellationPolicy: path(ROOTS_DASHBOARD, '/cancellation-policy'),
    addCancellationPolicy: path(ROOTS_DASHBOARD, '/add-cancellation-policy'),
    editCencellationPolicy: (id) => path(ROOTS_DASHBOARD, `/edit-cancellation-policy/${id}`),
  },
  category: {
    app: path(ROOTS_DASHBOARD, '/'),
    category: path(ROOTS_DASHBOARD, '/category'),
    AddCategory: path(ROOTS_DASHBOARD, '/AddCategory'),
    EditCategory: (id) => path(ROOTS_DASHBOARD, `/EditCategory/${id}`),
  },
  tags: {
    app: path(ROOTS_DASHBOARD, '/'),
    tags: path(ROOTS_DASHBOARD, '/tags'),
    addtag: path(ROOTS_DASHBOARD, '/addtag'),
    edittag: (id) => path(ROOTS_DASHBOARD, `/edittag/${id}`),
  },
  comments: {
    app: path(ROOTS_DASHBOARD, '/'),
    comments: path(ROOTS_DASHBOARD, '/comment'),
    addcomments: path(ROOTS_DASHBOARD, '/addcomment'),
    commentfilter: (id) => path(ROOTS_DASHBOARD, `/commentfilter/${id}`),
    editcomments: (id) => path(ROOTS_DASHBOARD, `/editcomment/${id}`),
    replycomments: (id) => path(ROOTS_DASHBOARD, `/replycomment/${id}`),
  },
  media: {
    app: path(ROOTS_DASHBOARD, '/'),
    media: path(ROOTS_DASHBOARD, '/media'),
    addmedia: path(ROOTS_DASHBOARD, '/addmedia'),
    mediaEdit: (id) => path(ROOTS_DASHBOARD, `/editmedia/${id}`),
    // editcomments: (id) => path(ROOTS_DASHBOARD, `/editcomment/${id}`),
    // replycomments: (id) => path(ROOTS_DASHBOARD, `/replycomment/${id}`),
  },
  page: {
    app: path(ROOTS_DASHBOARD, '/'),
    page: path(ROOTS_DASHBOARD, '/editpage'),
  },
  user: {
    app: path(ROOTS_DASHBOARD, '/'),
    user: path(ROOTS_DASHBOARD, '/user'),
    'edit-user': (id) => path(ROOTS_DASHBOARD, `/user/edit-user/${id}`),
    userdetail: path(ROOTS_DASHBOARD, '/user/userdetail'),
    viewuser: path(ROOTS_DASHBOARD, '/user/viewuser/:id'),

    spelleffect: (id) => path(ROOTS_DASHBOARD, `/spelleffect/${id}`),
  },
  element: {
    app: path(ROOTS_DASHBOARD, '/'),
    element: path(ROOTS_DASHBOARD, '/element'),
    editelement: (id) => path(ROOTS_DASHBOARD, `/editelement/${id}`),
    companyProfile: path(ROOTS_DASHBOARD, '/companyProfile'),
    addelement: path(ROOTS_DASHBOARD, '/addelement'),
  },
  host: {
    app: path(ROOTS_DASHBOARD, '/'),
    host: path(ROOTS_DASHBOARD, '/host'),
    edithost: (id) => path(ROOTS_DASHBOARD, `/edithost/${id}`),
    addhost: path(ROOTS_DASHBOARD, '/addhost'),
    spelleffect: (id) => path(ROOTS_DASHBOARD, `/spelleffect/${id}`),
  },
  facility: {
    app: path(ROOTS_DASHBOARD, '/'),
    facility: path(ROOTS_DASHBOARD, '/facility'),
    editfacility: (id) => path(ROOTS_DASHBOARD, `/editfacility/${id}`),
    addfacility: path(ROOTS_DASHBOARD, '/addfacility'),
    spelleffect: (id) => path(ROOTS_DASHBOARD, `/spelleffect/${id}`),
  },
  amenity: {
    app: path(ROOTS_DASHBOARD, '/'),
    amenity: path(ROOTS_DASHBOARD, '/feature'),
    editamenity: (id) => path(ROOTS_DASHBOARD, `/editfeature/${id}`),
    addamenity: path(ROOTS_DASHBOARD, '/addfeature'),
    spelleffect: (id) => path(ROOTS_DASHBOARD, `/spelleffect/${id}`),
  },
  map: {
    app: path(ROOTS_DASHBOARD, '/'),
    map: path(ROOTS_DASHBOARD, '/map'),
  },
  emailmanagement: {
    app: path(ROOTS_DASHBOARD, '/'),
    emailmanagement: path(ROOTS_DASHBOARD, '/emailmanagement'),
  },
  listing: {
    app: path(ROOTS_DASHBOARD, '/'),
    listing: path(ROOTS_DASHBOARD, '/listing'),
    editlisting: (id) => path(ROOTS_DASHBOARD, `/editlisting/${id}`),
    duplicate: (id) => path(ROOTS_DASHBOARD, `/duplicate/${id}`),

    addlisting: path(ROOTS_DASHBOARD, '/addlisting'),
    viewlisitng: path(ROOTS_DASHBOARD, '/viewlisitng'),
    spelleffect: (id) => path(ROOTS_DASHBOARD, `/spelleffect/${id}`),
  },
  favorite: {
    app: path(ROOTS_DASHBOARD, '/'),
    favorite: path(ROOTS_DASHBOARD, '/allfavorite'),
    editfavorite: (id) => path(ROOTS_DASHBOARD, `/editfavorite/${id}`),
    addfavorite: path(ROOTS_DASHBOARD, '/addfavorite'),
    viewfavorite: path(ROOTS_DASHBOARD, '/viewfavorite'),
    spelleffect: (id) => path(ROOTS_DASHBOARD, `/spelleffect/${id}`),
  },
  booking: {
    app: path(ROOTS_DASHBOARD, '/'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
    // editlisting: (id) => path(ROOTS_DASHBOARD, `/editlisting/${id}`),
    // addlisting: path(ROOTS_DASHBOARD, '/addlisting'),
    viewbooking: (id) => path(ROOTS_DASHBOARD, `/viewbooking/${id}`),
    confirmbooking: path(ROOTS_DASHBOARD, '/confirmbooking'),
    extracharges: (id) => path(ROOTS_DASHBOARD, `/extracharges/${id}`),
    spelleffect: (id) => path(ROOTS_DASHBOARD, `/spelleffect/${id}`),
  },

  message: {
    app: path(ROOTS_DASHBOARD, '/'),
    message: path(ROOTS_DASHBOARD, '/message'),
    blog: path(ROOTS_DASHBOARD, '/blog'),
    addblog: path(ROOTS_DASHBOARD, '/addblog'),
    editblog: (id) => path(ROOTS_DASHBOARD, `/editblog/${id}`),
    viewblog: (id) => path(ROOTS_DASHBOARD, `/viewblog/${id}`),
    spelleffect: (id) => path(ROOTS_DASHBOARD, `/spelleffect/${id}`),
  },
  payouts: {
    app: path(ROOTS_DASHBOARD, '/'),
    payouts: path(ROOTS_DASHBOARD, '/payouts'),
    payoutssearch: (id) => path(ROOTS_DASHBOARD, `/payoutssearch/${id}`),
    payoutsdetails: path(ROOTS_DASHBOARD, '/payoutsdetails'),
    spelleffect: (id) => path(ROOTS_DASHBOARD, `/spelleffect/${id}`),
  },
  invoices: {
    app: path(ROOTS_DASHBOARD, '/'),
    invoices: path(ROOTS_DASHBOARD, '/invoices'),
    invoicesdetails: path(ROOTS_DASHBOARD, '/invoicesdetails'),
    spelleffect: (id) => path(ROOTS_DASHBOARD, `/spelleffect/${id}`),
  },

  appointment: {
    app: path(ROOTS_DASHBOARD, '/'),
    appointment: path(ROOTS_DASHBOARD, '/appointment'),
    editappointment: (id) => path(ROOTS_DASHBOARD, `/editappointment/${id}`),
    appointmentdetail: (id) => path(ROOTS_DASHBOARD, `/appointmentdetail/${id}`),
    addappointment: path(ROOTS_DASHBOARD, '/addappointment'),
  },
  card: {
    app: path(ROOTS_DASHBOARD, '/'),
    card: path(ROOTS_DASHBOARD, '/card'),
    editcard: (id) => path(ROOTS_DASHBOARD, `/editcard/${id}`),
    carddetail: (id) => path(ROOTS_DASHBOARD, `/carddetail/${id}`),
    addcard: path(ROOTS_DASHBOARD, '/addcard'),
  },

  general: {
    app: path(ROOTS_DASHBOARD, '/'),
    subscription: path(ROOTS_DASHBOARD, '/subscription'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),

  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
